import styled from 'styled-components'

import FormikForm from '../../../form/FormikForm'
import FormSubmitButton from '../../../form/FormSubmitButton'
import FormFieldSelect from '../../../form/fields/FormFieldSelect'
import FormErrors from '../../../form/FormErrors'
import Card from '../../../Card'
import breakpoints from '../../../../theme/breakpoints'

export const CardWrapper = styled(Card)``

export const Title = styled.h5`
  ${({ theme }) => theme.textStyles.textLarge};
  margin-bottom: 3.2rem;
  text-align: center;
  color: ${({ theme }) => theme.colors.nightRider};
`

export const Divider = styled.div`
  width: 100%;
  border-top: 1px solid ${({ theme }) => theme.colors.grey4};
  margin-bottom: 3.2rem;
`

export const Form = styled(FormikForm)`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Fields = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 20px;
  align-items: center;
`

export const FieldSelect = styled(FormFieldSelect)`
  width: 100%;
  margin-bottom: 3.2rem;

  min-width: 25rem;

  ${breakpoints.up('tablet')} {
    min-width: 37rem;
  }
`

export const Errors = styled(FormErrors)``

export const SubmitButton = styled(FormSubmitButton)``
